<div class="flex items-center gap-2">
  @for (sns of snsLinks(); track sns.name) {
  <a
    [href]="sns.url"
    target="_blank"
    rel="noopener noreferrer"
    class="w-10 h-10 rounded-full bg-zinc-700 hover:bg-zinc-600 transition-colors flex items-center justify-center"
    [attr.aria-label]="sns.name">
    @if (sns.icon.startsWith('/') || sns.icon.startsWith('http')) {
    <img [src]="sns.icon" [alt]="sns.name + ' icon'" class="size-5" />
    } @else {
    <app-icon [name]="sns.icon" class="size-5! text-zinc-500" />
    }
  </a>
  }
</div>
